<!-- 加载动画 -->
<template>
  <div
    class="loading"
    :style="{
      width: size,
      height: size,
      borderTopColor: color,
      borderWidth: (size.split('px')[0] / 5) + 'px'
    }"
  ></div>
</template>

<script>
export default {
  props: {
    color: { type: String, default: "white" },
    size: { type: String, default: "24px" }
  },
  data() {
    return {};
  },
  mounted() {}
};
</script>
<style scoped>
/* @import url(); 引入css类 */
.loading {
  border-radius: 50%;
  width: 24px;
  height: 24px;
  border: 5px solid rgba(255, 255, 255, 0.2);
  border-top-color: white;
  animation: spin 750ms infinite linear;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/loading/loading.vue